import { render, staticRenderFns } from "./DropAreaMulti.vue?vue&type=template&id=00d9df34&scoped=true&"
import script from "./DropAreaMulti.vue?vue&type=script&lang=ts&"
export * from "./DropAreaMulti.vue?vue&type=script&lang=ts&"
import style0 from "./DropAreaMulti.vue?vue&type=style&index=0&id=00d9df34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d9df34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VIcon,VProgressLinear})
